/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import { InterviewRoleProvider } from "./src/utils/interviewRole"

export const wrapRootElement = ({ element }) => (
  <InterviewRoleProvider>{element}</InterviewRoleProvider>
)
